"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverridesByPathname = getOverridesByPathname;
exports.getCurrentOverrides = getCurrentOverrides;
exports.setCurrentPathname = setCurrentPathname;
exports.rehydrateOverridesForPathname = rehydrateOverridesForPathname;
exports.loadOverridesForPathname = loadOverridesForPathname;
exports.preloadOverridesForPathname = preloadOverridesForPathname;
exports._outsmartly_two_promises_settled = _outsmartly_two_promises_settled;
exports.overridesByPathname = void 0;

var _env = require("./env.js");

var _getOverrideResults = require("./getOverrideResults.js");

var hasRehydrated = typeof window !== 'object';
var currentPathname = typeof location === 'object' ? location.pathname : '';
var currentHost;
var overridesByPathname = Object.create(null);
exports.overridesByPathname = overridesByPathname;

function getOverridesByPathname(pathname) {
  if (!_env._outsmartly_enabled) {
    return;
  }

  if (!hasRehydrated) {
    throw new Error('Outsmartly has not been initialized client-side. rehydrateOverridesForPathname(location.pathname) must be called before any attempt to render.');
  }

  return overridesByPathname[pathname];
}

function getCurrentOverrides() {
  return getOverridesByPathname(currentPathname);
}

function reportLogs(logs, pathname) {
  if (!logs || logs.length === 0) {
    return;
  }

  console.group("%c(".concat(logs.length, ") Outsmartly Edge logs for path ").concat(pathname), 'font-size: 12px; font-weight: normal;');

  var _iterator = _createForOfIteratorHelper(logs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var message = _step.value;
      var _message$type = message.type,
          type = _message$type === void 0 ? 'log' : _message$type,
          originator = message.originator,
          title = message.title,
          _message$args = message.args,
          args = _message$args === void 0 ? [] : _message$args;
      var pre = '%c[Outsmartly';

      if (originator) {
        pre += " ".concat(message.originator.toUpperCase());
      }

      pre += ']';

      if (title) {
        pre += " ".concat(title, ":");
      }

      switch (type) {
        case 'log':
          {
            var _console;

            (_console = console).log.apply(_console, [pre, 'margin-left: 10px; color: #999;'].concat(_toConsumableArray(args)));

            break;
          }

        case 'warn':
          {
            var _console2;

            (_console2 = console).warn.apply(_console2, [pre, 'color: #999;'].concat(_toConsumableArray(args)));

            break;
          }

        case 'error':
          {
            var _console3;

            (_console3 = console).error.apply(_console3, [pre, 'color: #999;'].concat(_toConsumableArray(args)));

            break;
          }

        default:
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  console.groupEnd();
}

function setCurrentPathname(pathname) {
  currentPathname = pathname;
}

function setOverridesForPathname(data, pathname) {
  if (!data.host) {
    data.host = currentHost;
  }

  overridesByPathname[pathname] = {
    pathname: pathname,
    data: data,
    isLoading: false
  };

  try {
    reportLogs(data.logs, pathname);
  } catch (e) {
    console.error(e);
  }
}

function rehydrateOverridesForPathname(pathname) {
  hasRehydrated = true;
  setCurrentPathname(pathname);
  var outsmartlyScriptData = (0, _getOverrideResults.getOutsmartlyScriptData)();

  if (!outsmartlyScriptData) {
    return;
  } // This might be undefined (e.g. when not in dev mode),
  // but it's still safe to set it anyway.


  currentHost = outsmartlyScriptData.host;
  setOverridesForPathname(outsmartlyScriptData, pathname);
  return;
}

function loadOverridesForPathname(pathname, options) {
  return preloadOverridesForPathname(pathname, options);
}

function preloadOverridesForPathname(pathname, _ref) {
  var _ref$cache = _ref.cache,
      cache = _ref$cache === void 0 ? false : _ref$cache,
      host = _ref.host;

  if (!_env._outsmartly_enabled) {
    return Promise.resolve();
  }

  if (host) {
    currentHost = host;
  }

  if (cache) {
    var existing = getOverridesByPathname(pathname);

    if (existing) {
      // We don't want concurrent requests that creates a race condition
      // for which one updates last.
      if (existing.isLoading) {
        return existing.suspensePromise; // We don't currently update overrides once they've been visited.
      } else {
        return Promise.resolve();
      }
    }
  }

  var suspensePromise = new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
      var endpoint, resp, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              endpoint = "/__outsmartly__/overrides?route=".concat(encodeURIComponent(pathname));
              _context.next = 4;
              return fetch(currentHost ? currentHost + endpoint : endpoint);

            case 4:
              resp = _context.sent;
              _context.next = 7;
              return resp.json();

            case 7:
              data = _context.sent;
              setOverridesForPathname(data, pathname);
              resolve();
              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              overridesByPathname[pathname] = {
                pathname: pathname,
                isLoading: false
              };
              reject(_context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
  overridesByPathname[pathname] = {
    pathname: pathname,
    suspensePromise: suspensePromise,
    isLoading: true
  };
  return suspensePromise;
} // Instead of relying on Promise.allSettled() or even Promise.all() we make a simple
// one-off helper. Saves on bundle size since we don't need full spec compliance.


function _outsmartly_two_promises_settled(a, b) {
  return new Promise(function (resolve) {
    var results = new Array(2);

    var checkIfDone = function checkIfDone() {
      if (results[0] && results[1]) {
        resolve(results);
      }
    };

    var wait = function wait(promise, index) {
      return promise.then(function (value) {
        results[index] = {
          status: 'fulfilled',
          value: value
        };
      }, function (reason) {
        results[index] = {
          status: 'rejected',
          reason: reason
        };
      }).then(checkIfDone);
    };

    wait(a, 0);
    wait(b, 1);
  });
}